<template>
  <div>
    <transition name="modal">
      <div class="modal-mask" v-if="showModal" :class="`${classes}`">
        <div class="modal-wrapper">
          <div class="modal-container" :class="`${containerClass}`">
            <div class="modal-header">
              <slot name="header"></slot>
              <button
                type="button"
                v-if="isCloseButtonShown"
                class="modal-close-button"
                @click="handleClose"
              >
                <close-icon />
              </button>
            </div>

            <div class="modal-body">
              <slot name="body"></slot>
            </div>

            <div class="modal-footer">
              <slot name="footer"></slot>
            </div>
          </div>
          <div class="modal-backdrop" @click.stop="handleClose"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CloseIcon from "./Icons/Close";

export default {
  props: {
    isShown: {
      type: Boolean,
      default: false
    },
    isCloseButtonShown: {
      type: Boolean,
      default: true
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    classes: {
      type: String,
      default: ""
    },
    containerClass: {
      type: String,
      default: ""
    }
  },
  data(props) {
    return {
      showModal: props.isShown || false
    };
  },
  components: {
    CloseIcon
  },
  watch: {
    showModal: function(isModalShown) {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);

      const paddingTop = document.body.dataset["paddingTop"];

      document.body.style.cssText = isModalShown
        ? `padding-top: ${paddingTop}; height: ${vh * 100}px; overflow: hidden`
        : `padding-top: ${paddingTop}; height: '';overflow: ''`;

      if (!isModalShown) {
        this.$emit("closeModal");
      }
    },
    isShown: function(isShown) {
      this.showModal = isShown;
    }
  },
  methods: {
    handleClose: function() {
      this.showModal = false;

      if (typeof this.onClose === "function") {
        this.onClose();
      }
    }
  }
};
</script>

<style lang="scss">
@import "../assets/sass/_variables.scss";

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  transition: opacity 0.3s ease;
  background: rgba($sv-black, 0.8);
  overflow: auto;
}

.modal-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.modal-container {
  position: relative;
  width: 100%;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  max-height: 100%;
  overflow: auto;
  margin: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  z-index: 5;
  transition: all 0.3s ease;
}

@media screen and (min-width: $screen-md-min) {
  .modal-container {
    width: 300px;
    height: auto;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-header {
  position: relative;
  z-index: 100;
}

.modal-close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  padding: 10px;
  margin: 0;
  border: none;
  cursor: pointer;
  font-size: 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter,
.modal-leave-active {
  .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
</style>
